import { render, staticRenderFns } from "./OrcamentoLoading.vue?vue&type=template&id=f4b2acd0&scoped=true"
import script from "./OrcamentoLoading.vue?vue&type=script&lang=js"
export * from "./OrcamentoLoading.vue?vue&type=script&lang=js"
import style0 from "./OrcamentoLoading.vue?vue&type=style&index=0&id=f4b2acd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b2acd0",
  null
  
)

export default component.exports